import React from 'react';

import {
    yMapHintContainer, yMapHintDescription, yMapHintDescriptionLite, yMapHintInfo, yMapHintPreview
} from '@search/ymap/src/hint';
import { formatPrice } from '@search/helpers/src/formatPrice';
import { formatArea } from '@search/helpers/src/formatArea';
import { Currency } from '@search/filter-enums/enums/Currency';

import { OfferYMapPlacemarkTooltip } from '../placemark/Placemark';
import { OfferYMapLandPlacemarkProps } from './LandPlacemarkProps';

export function OfferYMapLandPlacemark({
    id,
    price,
    coordinates,
    totalArea,
    preview,
    url,
    isVisited,
    isActive,
    isFavorite,
    onClick,
    targetBlank = true,
    isHighlighted,
    zIndexes,
    dataTest
}: OfferYMapLandPlacemarkProps) {
    const areaPriceStr = totalArea ? `${formatPrice({
        value: (price.rubPrice ?? price.value) / totalArea.value,
        currency: price.rubPrice ? Currency.RUB : price.currency,
        displayCurrency: true,
        noFractional: true
    })} за сотку` : undefined;

    const hintLayout = yMapHintContainer(`
        ${yMapHintPreview(preview)}
        ${yMapHintInfo(`
            ${totalArea ? yMapHintDescription(formatArea(totalArea)) : ''}
            ${areaPriceStr ? yMapHintDescriptionLite(areaPriceStr) : ''}
        `)}
    `);

    const priceStr = formatPrice({
        value: price.rubPrice ?? price.value,
        currency: price.rubPrice ? Currency.RUB : price.currency,
        inWords: true
    });

    return (<OfferYMapPlacemarkTooltip
        id={id}
        url={url}
        isActive={isActive}
        isVisited={isVisited}
        onClick={onClick}
        title={priceStr}
        dataTest={dataTest}
        targetBlank={targetBlank}
        coordinates={{ y: coordinates.latitude, x: coordinates.longitude }}
        hintLayout={hintLayout}
        isHighlighted={isHighlighted}
        zIndexes={zIndexes}
        isFavorite={isFavorite}
    />);
}
